// Checkout localization. The store-level `language` (fr|en|es|nl|it|de|pl) drives
// every customer-facing string on the checkout, success and cancelled pages.
// Admin-entered texts (shipping option names/descriptions, support email…)
// are intentionally NOT translated — they render exactly as the merchant typed.

export const CHECKOUT_LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'it', label: 'Italiano' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pl', label: 'Polski' },
  { code: 'sv', label: 'Svenska' },
];

export const TRANSLATIONS = {
  fr: {
    trust_secure: 'Paiement 100% sécurisé',
    trust_fast_ship: 'Expédition rapide',
    trust_money_back: 'Satisfait ou remboursé',
    finalize_order: 'Finaliser votre commande',
    one_step: 'Tout en une seule étape · paiement instantané',
    your_details: 'Vos coordonnées',
    shipping: 'Livraison',
    payment: 'Paiement',
    loading_payment: 'Chargement du module de paiement…',
    summary: 'Récapitulatif',
    qty: 'Qté',
    subtotal: 'Sous-total',
    to_choose: '— à choisir —',
    total: 'Total',
    note_encrypted: 'Vos données sont chiffrées de bout en bout. Paiement certifié PCI DSS Level 1.',
    note_ship_after: 'Expédition après confirmation du paiement. Vous recevrez un email avec votre numéro de suivi.',
    note_money_back: 'Satisfait ou remboursé sous 14 jours.',
    need_help: "Besoin d'aide ?",
    store_fallback: 'Boutique',
    bogo_free: '🎁 1 acheté 1 offert',
    bogo_percent_summary: '🎁 2ème article réduit',
    offer_free: '🎁 1 acheté 1 offert',
    offer_percent: '🎁 2ème à -{pct}%',
    skipped_one: "1 article du panier n'est pas disponible pour ce paiement rapide et n'a pas été inclus dans le total.",
    skipped_many: "{n} articles du panier ne sont pas disponibles pour ce paiement rapide et n'ont pas été inclus dans le total.",
    email: 'Email',
    email_ph: 'vous@exemple.com',
    first_name: 'Prénom',
    last_name: 'Nom',
    address: 'Adresse',
    address_ph: 'Commencez à taper pour rechercher…',
    searching: 'Recherche…',
    no_result: 'Aucun résultat — saisissez manuellement',
    city: 'Ville',
    postal_code: 'Code postal',
    country: 'Pays',
    phone: 'Téléphone',
    no_shipping: 'Aucune option de livraison disponible. Veuillez contacter le marchand.',
    free: 'Gratuit',
    err_choose_shipping: 'Veuillez choisir une option de livraison.',
    toast_choose_shipping: 'Choisissez une option de livraison',
    err_complete_info: 'Veuillez compléter vos coordonnées ci-dessus.',
    toast_incomplete_info: 'Coordonnées incomplètes',
    err_check_payment: 'Vérifiez vos informations de paiement',
    err_payment: 'Erreur de paiement',
    err_generic: 'Erreur',
    processing: 'Paiement en cours...',
    pay: 'Payer',
    choose_shipping_btn: 'Choisissez une livraison',
    terms: 'En cliquant "Payer", vous acceptez nos conditions générales. Aucun débit avant validation.',
    secure_pay: 'Paiement sécurisé et chiffré',
    card_gate_hint: 'Le paiement s’activera automatiquement une fois votre moyen de paiement renseigné.',
    or_pay_card: 'ou payer par carte',
    product_not_found: 'Produit introuvable',
    loading_secure: 'Chargement du paiement sécurisé…',
    ph_cardholder: 'Nom sur la carte',
    ph_cardnumber: 'Numéro de carte',
    secured_viva: 'Paiement sécurisé par Viva Wallet · vos données carte ne transitent jamais par nos serveurs.',
    secured_payzen: 'Paiement sécurisé par PayZen · vos données carte ne transitent jamais par nos serveurs.',
    owner_only_overline: 'Accès réservé',
    owner_only_title: "Cette page est réservée à l'acheteur",
    owner_only_text: "Le récapitulatif de commande n'est visible que depuis le navigateur qui a effectué l'achat. Si c'est vous, rouvrez la page depuis l'onglet de votre commande ou consultez l'e-mail de confirmation.",
    payzen_embedded_hint: 'Renseignez vos coordonnées et choisissez la livraison : le formulaire de carte sécurisé apparaîtra ici.',
    viva_embedded_hint: 'Renseignez tous vos coordonnées et choisissez la livraison, puis cliquez sur « Payer » : le formulaire de carte sécurisé apparaîtra ci-dessous.',
    card_declined: 'Carte refusée ou informations invalides',
    payment_not_confirmed: 'Paiement non confirmé',
    verification: 'Vérification',
    confirming_payment: 'Confirmation du paiement...',
    validating: 'Validation du paiement puis création de la commande.',
    payment_confirmed_overline: '— Paiement confirmé',
    thank_you: 'Merci pour votre achat',
    payment_processed_pre: 'Votre paiement de',
    payment_processed_post: 'a été traité avec succès.',
    order: 'Commande',
    redirecting: 'Redirection vers la confirmation de commande…',
    shopify_failed_pre: 'Paiement OK mais création de la commande échouée :',
    back_home: "Retour à l'accueil",
    pending_overline: '— Validation en cours',
    pending_title: 'Paiement en cours de validation',
    pending_body_amount_pre: 'Votre paiement de',
    pending_body_no_amount: 'Votre paiement',
    pending_body_rest: "est en cours de validation par votre moyen de paiement (ex. Klarna). Vous recevrez une confirmation par email dès qu'il est accepté — votre commande sera alors traitée automatiquement.",
    timeout_overline: 'Délai dépassé',
    fail_overline: 'Échec',
    payment_not_confirmed_title: 'Paiement non confirmé',
    retry_contact: 'Veuillez réessayer ou contacter le support.',
    cancelled_overline: '— Paiement annulé',
    no_charge: 'Aucun débit effectué',
    can_retry: 'Vous pouvez relancer un paiement à tout moment.',
  },
  en: {
    trust_secure: '100% secure payment',
    trust_fast_ship: 'Fast shipping',
    trust_money_back: 'Satisfaction guaranteed',
    finalize_order: 'Complete your order',
    one_step: 'All in one step · instant payment',
    your_details: 'Your details',
    shipping: 'Shipping',
    payment: 'Payment',
    loading_payment: 'Loading payment module…',
    summary: 'Summary',
    qty: 'Qty',
    subtotal: 'Subtotal',
    to_choose: '— to choose —',
    total: 'Total',
    note_encrypted: 'Your data is encrypted end to end. PCI DSS Level 1 certified payment.',
    note_ship_after: 'Shipping after payment confirmation. You will receive an email with your tracking number.',
    note_money_back: '14-day money-back guarantee.',
    need_help: 'Need help?',
    store_fallback: 'Store',
    bogo_free: '🎁 Buy one get one free',
    bogo_percent_summary: '🎁 2nd item discounted',
    offer_free: '🎁 Buy one get one free',
    offer_percent: '🎁 2nd at -{pct}%',
    skipped_one: '1 cart item is not available for this express checkout and was not included in the total.',
    skipped_many: '{n} cart items are not available for this express checkout and were not included in the total.',
    email: 'Email',
    email_ph: 'you@example.com',
    first_name: 'First name',
    last_name: 'Last name',
    address: 'Address',
    address_ph: 'Start typing to search…',
    searching: 'Searching…',
    no_result: 'No results — enter manually',
    city: 'City',
    postal_code: 'Postal code',
    country: 'Country',
    phone: 'Phone',
    no_shipping: 'No shipping option available. Please contact the merchant.',
    free: 'Free',
    err_choose_shipping: 'Please choose a shipping option.',
    toast_choose_shipping: 'Choose a shipping option',
    err_complete_info: 'Please complete your details above.',
    toast_incomplete_info: 'Incomplete details',
    err_check_payment: 'Check your payment information',
    err_payment: 'Payment error',
    err_generic: 'Error',
    processing: 'Processing payment...',
    pay: 'Pay',
    choose_shipping_btn: 'Choose a shipping option',
    terms: 'By clicking "Pay", you accept our terms and conditions. No charge before validation.',
    secure_pay: 'Secure and encrypted payment',
    card_gate_hint: 'Payment unlocks automatically once your payment method is filled in.',
    or_pay_card: 'or pay by card',
    product_not_found: 'Product not found',
    loading_secure: 'Loading secure payment…',
    ph_cardholder: 'Name on card',
    ph_cardnumber: 'Card number',
    secured_viva: 'Payment secured by Viva Wallet · your card data never passes through our servers.',
    secured_payzen: 'Payment secured by PayZen · your card data never passes through our servers.',
    owner_only_overline: 'Restricted access',
    owner_only_title: 'This page is reserved for the buyer',
    owner_only_text: "The order summary is only visible from the browser that made the purchase. If that's you, reopen the page from your order tab or check your confirmation email.",
    payzen_embedded_hint: 'Fill in your details and choose shipping: the secure card form will appear here.',
    viva_embedded_hint: 'Fill in all your details and choose shipping, then click "Pay": the secure card form will appear below.',
    card_declined: 'Card declined or invalid information',
    payment_not_confirmed: 'Payment not confirmed',
    verification: 'Verification',
    confirming_payment: 'Confirming payment...',
    validating: 'Validating payment then creating the order.',
    payment_confirmed_overline: '— Payment confirmed',
    thank_you: 'Thank you for your purchase',
    payment_processed_pre: 'Your payment of',
    payment_processed_post: 'has been processed successfully.',
    order: 'Order',
    redirecting: 'Redirecting to order confirmation…',
    shopify_failed_pre: 'Payment OK but order creation failed:',
    back_home: 'Back to home',
    pending_overline: '— Validation in progress',
    pending_title: 'Payment being validated',
    pending_body_amount_pre: 'Your payment of',
    pending_body_no_amount: 'Your payment',
    pending_body_rest: 'is being validated by your payment method (e.g. Klarna). You will receive an email confirmation as soon as it is accepted — your order will then be processed automatically.',
    timeout_overline: 'Timed out',
    fail_overline: 'Failed',
    payment_not_confirmed_title: 'Payment not confirmed',
    retry_contact: 'Please try again or contact support.',
    cancelled_overline: '— Payment cancelled',
    no_charge: 'No charge was made',
    can_retry: 'You can start a payment again at any time.',
  },
  es: {
    trust_secure: 'Pago 100% seguro',
    trust_fast_ship: 'Envío rápido',
    trust_money_back: 'Satisfecho o reembolsado',
    finalize_order: 'Finaliza tu pedido',
    one_step: 'Todo en un solo paso · pago instantáneo',
    your_details: 'Tus datos',
    shipping: 'Envío',
    payment: 'Pago',
    loading_payment: 'Cargando el módulo de pago…',
    summary: 'Resumen',
    qty: 'Cant.',
    subtotal: 'Subtotal',
    to_choose: '— a elegir —',
    total: 'Total',
    note_encrypted: 'Tus datos están cifrados de extremo a extremo. Pago certificado PCI DSS Level 1.',
    note_ship_after: 'Envío tras la confirmación del pago. Recibirás un email con tu número de seguimiento.',
    note_money_back: 'Satisfecho o reembolsado en 14 días.',
    need_help: '¿Necesitas ayuda?',
    store_fallback: 'Tienda',
    bogo_free: '🎁 Compra uno y llévate otro gratis',
    bogo_percent_summary: '🎁 2º artículo con descuento',
    offer_free: '🎁 Compra uno y llévate otro gratis',
    offer_percent: '🎁 2º a -{pct}%',
    skipped_one: '1 artículo del carrito no está disponible para este pago rápido y no se ha incluido en el total.',
    skipped_many: '{n} artículos del carrito no están disponibles para este pago rápido y no se han incluido en el total.',
    email: 'Email',
    email_ph: 'tu@ejemplo.com',
    first_name: 'Nombre',
    last_name: 'Apellido',
    address: 'Dirección',
    address_ph: 'Empieza a escribir para buscar…',
    searching: 'Buscando…',
    no_result: 'Sin resultados — introduce manualmente',
    city: 'Ciudad',
    postal_code: 'Código postal',
    country: 'País',
    phone: 'Teléfono',
    no_shipping: 'No hay opción de envío disponible. Por favor, contacta con el comerciante.',
    free: 'Gratis',
    err_choose_shipping: 'Por favor, elige una opción de envío.',
    toast_choose_shipping: 'Elige una opción de envío',
    err_complete_info: 'Por favor, completa tus datos arriba.',
    toast_incomplete_info: 'Datos incompletos',
    err_check_payment: 'Comprueba tu información de pago',
    err_payment: 'Error de pago',
    err_generic: 'Error',
    processing: 'Procesando el pago...',
    pay: 'Pagar',
    choose_shipping_btn: 'Elige un envío',
    terms: 'Al hacer clic en "Pagar", aceptas nuestras condiciones generales. Ningún cargo antes de la validación.',
    secure_pay: 'Pago seguro y cifrado',
    card_gate_hint: 'El pago se activará automáticamente cuando completes tu método de pago.',
    or_pay_card: 'o pagar con tarjeta',
    product_not_found: 'Producto no encontrado',
    loading_secure: 'Cargando el pago seguro…',
    ph_cardholder: 'Nombre en la tarjeta',
    ph_cardnumber: 'Número de tarjeta',
    secured_viva: 'Pago asegurado por Viva Wallet · los datos de tu tarjeta nunca pasan por nuestros servidores.',
    secured_payzen: 'Pago seguro con PayZen · los datos de su tarjeta nunca pasan por nuestros servidores.',
    owner_only_overline: 'Acceso restringido',
    owner_only_title: 'Esta página está reservada al comprador',
    owner_only_text: 'El resumen del pedido solo es visible desde el navegador que realizó la compra. Si es usted, vuelva a abrir la página desde la pestaña de su pedido o consulte el correo de confirmación.',
    payzen_embedded_hint: 'Complete sus datos y elija el envío: el formulario de tarjeta seguro aparecerá aquí.',
    viva_embedded_hint: 'Completa todos tus datos y elige el envío, luego pulsa "Pagar": el formulario de tarjeta seguro aparecerá debajo.',
    card_declined: 'Tarjeta rechazada o información no válida',
    payment_not_confirmed: 'Pago no confirmado',
    verification: 'Verificación',
    confirming_payment: 'Confirmando el pago...',
    validating: 'Validando el pago y creando el pedido.',
    payment_confirmed_overline: '— Pago confirmado',
    thank_you: 'Gracias por tu compra',
    payment_processed_pre: 'Tu pago de',
    payment_processed_post: 'se ha procesado con éxito.',
    order: 'Pedido',
    redirecting: 'Redirigiendo a la confirmación del pedido…',
    shopify_failed_pre: 'Pago OK pero la creación del pedido falló:',
    back_home: 'Volver al inicio',
    pending_overline: '— Validación en curso',
    pending_title: 'Pago en proceso de validación',
    pending_body_amount_pre: 'Tu pago de',
    pending_body_no_amount: 'Tu pago',
    pending_body_rest: 'está siendo validado por tu método de pago (p. ej. Klarna). Recibirás una confirmación por email en cuanto sea aceptado — tu pedido se procesará entonces automáticamente.',
    timeout_overline: 'Tiempo agotado',
    fail_overline: 'Error',
    payment_not_confirmed_title: 'Pago no confirmado',
    retry_contact: 'Por favor, inténtalo de nuevo o contacta con soporte.',
    cancelled_overline: '— Pago cancelado',
    no_charge: 'No se realizó ningún cargo',
    can_retry: 'Puedes iniciar un pago de nuevo en cualquier momento.',
  },
  nl: {
    trust_secure: '100% veilig betalen',
    trust_fast_ship: 'Snelle verzending',
    trust_money_back: 'Niet goed, geld terug',
    finalize_order: 'Rond je bestelling af',
    one_step: 'Alles in één stap · directe betaling',
    your_details: 'Je gegevens',
    shipping: 'Verzending',
    payment: 'Betaling',
    loading_payment: 'Betaalmodule laden…',
    summary: 'Overzicht',
    qty: 'Aantal',
    subtotal: 'Subtotaal',
    to_choose: '— te kiezen —',
    total: 'Totaal',
    note_encrypted: 'Je gegevens zijn end-to-end versleuteld. Betaling gecertificeerd PCI DSS Level 1.',
    note_ship_after: 'Verzending na bevestiging van de betaling. Je ontvangt een e-mail met je trackingnummer.',
    note_money_back: '14 dagen niet-goed-geld-terug.',
    need_help: 'Hulp nodig?',
    store_fallback: 'Winkel',
    bogo_free: '🎁 1 + 1 gratis',
    bogo_percent_summary: '🎁 2e artikel met korting',
    offer_free: '🎁 1 + 1 gratis',
    offer_percent: '🎁 2e voor -{pct}%',
    skipped_one: '1 artikel in je winkelmandje is niet beschikbaar voor deze snelle betaling en is niet meegerekend in het totaal.',
    skipped_many: '{n} artikelen in je winkelmandje zijn niet beschikbaar voor deze snelle betaling en zijn niet meegerekend in het totaal.',
    email: 'E-mail',
    email_ph: 'jij@voorbeeld.com',
    first_name: 'Voornaam',
    last_name: 'Achternaam',
    address: 'Adres',
    address_ph: 'Begin te typen om te zoeken…',
    searching: 'Zoeken…',
    no_result: 'Geen resultaten — handmatig invoeren',
    city: 'Stad',
    postal_code: 'Postcode',
    country: 'Land',
    phone: 'Telefoon',
    no_shipping: 'Geen verzendoptie beschikbaar. Neem contact op met de verkoper.',
    free: 'Gratis',
    err_choose_shipping: 'Kies een verzendoptie.',
    toast_choose_shipping: 'Kies een verzendoptie',
    err_complete_info: 'Vul je gegevens hierboven aan.',
    toast_incomplete_info: 'Onvolledige gegevens',
    err_check_payment: 'Controleer je betaalgegevens',
    err_payment: 'Betaalfout',
    err_generic: 'Fout',
    processing: 'Betaling verwerken...',
    pay: 'Betalen',
    choose_shipping_btn: 'Kies een verzending',
    terms: 'Door op "Betalen" te klikken, ga je akkoord met onze algemene voorwaarden. Geen afschrijving vóór validatie.',
    secure_pay: 'Veilige en versleutelde betaling',
    card_gate_hint: 'De betaling wordt automatisch geactiveerd zodra je je betaalmethode hebt ingevuld.',
    or_pay_card: 'of betaal met kaart',
    product_not_found: 'Product niet gevonden',
    loading_secure: 'Veilige betaling laden…',
    ph_cardholder: 'Naam op de kaart',
    ph_cardnumber: 'Kaartnummer',
    secured_viva: 'Betaling beveiligd door Viva Wallet · je kaartgegevens komen nooit langs onze servers.',
    secured_payzen: 'Betaling beveiligd door PayZen · uw kaartgegevens passeren nooit onze servers.',
    owner_only_overline: 'Beperkte toegang',
    owner_only_title: 'Deze pagina is voorbehouden aan de koper',
    owner_only_text: 'Het besteloverzicht is alleen zichtbaar vanuit de browser waarmee de aankoop is gedaan. Bent u dat, open de pagina dan opnieuw vanuit uw besteltabblad of bekijk de bevestigingsmail.',
    payzen_embedded_hint: 'Vul uw gegevens in en kies de verzending: het beveiligde kaartformulier verschijnt hier.',
    viva_embedded_hint: 'Vul al je gegevens in en kies verzending, klik dan op "Betalen": het beveiligde kaartformulier verschijnt hieronder.',
    card_declined: 'Kaart geweigerd of ongeldige gegevens',
    payment_not_confirmed: 'Betaling niet bevestigd',
    verification: 'Verificatie',
    confirming_payment: 'Betaling bevestigen...',
    validating: 'Betaling valideren en de bestelling aanmaken.',
    payment_confirmed_overline: '— Betaling bevestigd',
    thank_you: 'Bedankt voor je aankoop',
    payment_processed_pre: 'Je betaling van',
    payment_processed_post: 'is succesvol verwerkt.',
    order: 'Bestelling',
    redirecting: 'Doorsturen naar de orderbevestiging…',
    shopify_failed_pre: 'Betaling OK maar aanmaken bestelling mislukt:',
    back_home: 'Terug naar home',
    pending_overline: '— Validatie bezig',
    pending_title: 'Betaling wordt gevalideerd',
    pending_body_amount_pre: 'Je betaling van',
    pending_body_no_amount: 'Je betaling',
    pending_body_rest: 'wordt gevalideerd door je betaalmethode (bijv. Klarna). Je ontvangt een e-mailbevestiging zodra deze is geaccepteerd — je bestelling wordt dan automatisch verwerkt.',
    timeout_overline: 'Time-out',
    fail_overline: 'Mislukt',
    payment_not_confirmed_title: 'Betaling niet bevestigd',
    retry_contact: 'Probeer het opnieuw of neem contact op met support.',
    cancelled_overline: '— Betaling geannuleerd',
    no_charge: 'Er is niets afgeschreven',
    can_retry: 'Je kunt op elk moment opnieuw een betaling starten.',
  },
  it: {
    trust_secure: 'Pagamento 100% sicuro',
    trust_fast_ship: 'Spedizione rapida',
    trust_money_back: 'Soddisfatti o rimborsati',
    finalize_order: 'Completa il tuo ordine',
    one_step: 'Tutto in un solo passaggio · pagamento istantaneo',
    your_details: 'I tuoi dati',
    shipping: 'Spedizione',
    payment: 'Pagamento',
    loading_payment: 'Caricamento del modulo di pagamento…',
    summary: 'Riepilogo',
    qty: 'Qtà',
    subtotal: 'Subtotale',
    to_choose: '— da scegliere —',
    total: 'Totale',
    note_encrypted: 'I tuoi dati sono crittografati end-to-end. Pagamento certificato PCI DSS Level 1.',
    note_ship_after: 'Spedizione dopo la conferma del pagamento. Riceverai un email con il numero di tracciamento.',
    note_money_back: 'Soddisfatti o rimborsati entro 14 giorni.',
    need_help: 'Hai bisogno di aiuto?',
    store_fallback: 'Negozio',
    bogo_free: '🎁 Prendi 2 paghi 1',
    bogo_percent_summary: '🎁 2° articolo scontato',
    offer_free: '🎁 Prendi 2 paghi 1',
    offer_percent: '🎁 2° a -{pct}%',
    skipped_one: '1 articolo del carrello non è disponibile per questo pagamento rapido e non è stato incluso nel totale.',
    skipped_many: '{n} articoli del carrello non sono disponibili per questo pagamento rapido e non sono stati inclusi nel totale.',
    email: 'Email',
    email_ph: 'tu@esempio.com',
    first_name: 'Nome',
    last_name: 'Cognome',
    address: 'Indirizzo',
    address_ph: 'Inizia a digitare per cercare…',
    searching: 'Ricerca…',
    no_result: 'Nessun risultato — inserisci manualmente',
    city: 'Città',
    postal_code: 'CAP',
    country: 'Paese',
    phone: 'Telefono',
    no_shipping: 'Nessuna opzione di spedizione disponibile. Contatta il commerciante.',
    free: 'Gratis',
    err_choose_shipping: 'Scegli un’opzione di spedizione.',
    toast_choose_shipping: 'Scegli un’opzione di spedizione',
    err_complete_info: 'Completa i tuoi dati qui sopra.',
    toast_incomplete_info: 'Dati incompleti',
    err_check_payment: 'Controlla le informazioni di pagamento',
    err_payment: 'Errore di pagamento',
    err_generic: 'Errore',
    processing: 'Pagamento in corso...',
    pay: 'Paga',
    choose_shipping_btn: 'Scegli una spedizione',
    terms: 'Cliccando su "Paga", accetti le nostre condizioni generali. Nessun addebito prima della convalida.',
    secure_pay: 'Pagamento sicuro e crittografato',
    card_gate_hint: 'Il pagamento si attiverà automaticamente una volta inseriti i dati di pagamento.',
    or_pay_card: 'o paga con carta',
    product_not_found: 'Prodotto non trovato',
    loading_secure: 'Caricamento del pagamento sicuro…',
    ph_cardholder: 'Nome sulla carta',
    ph_cardnumber: 'Numero della carta',
    secured_viva: 'Pagamento protetto da Viva Wallet · i dati della tua carta non passano mai dai nostri server.',
    secured_payzen: 'Pagamento protetto da PayZen · i dati della carta non transitano mai sui nostri server.',
    owner_only_overline: 'Accesso riservato',
    owner_only_title: "Questa pagina è riservata all'acquirente",
    owner_only_text: "Il riepilogo dell'ordine è visibile solo dal browser che ha effettuato l'acquisto. Se sei tu, riapri la pagina dalla scheda del tuo ordine o consulta l'e-mail di conferma.",
    payzen_embedded_hint: 'Inserisci i tuoi dati e scegli la spedizione: il modulo carta sicuro apparirà qui.',
    viva_embedded_hint: 'Compila tutti i tuoi dati e scegli la spedizione, poi premi "Paga": il modulo carta sicuro comparirà qui sotto.',
    card_declined: 'Carta rifiutata o informazioni non valide',
    payment_not_confirmed: 'Pagamento non confermato',
    verification: 'Verifica',
    confirming_payment: 'Conferma del pagamento...',
    validating: 'Convalida del pagamento e creazione dell’ordine.',
    payment_confirmed_overline: '— Pagamento confermato',
    thank_you: 'Grazie per il tuo acquisto',
    payment_processed_pre: 'Il tuo pagamento di',
    payment_processed_post: 'è stato elaborato con successo.',
    order: 'Ordine',
    redirecting: 'Reindirizzamento alla conferma dell’ordine…',
    shopify_failed_pre: 'Pagamento OK ma creazione dell’ordine fallita:',
    back_home: 'Torna alla home',
    pending_overline: '— Convalida in corso',
    pending_title: 'Pagamento in fase di convalida',
    pending_body_amount_pre: 'Il tuo pagamento di',
    pending_body_no_amount: 'Il tuo pagamento',
    pending_body_rest: 'è in fase di convalida dal tuo metodo di pagamento (es. Klarna). Riceverai una conferma via email non appena sarà accettato — il tuo ordine verrà poi elaborato automaticamente.',
    timeout_overline: 'Tempo scaduto',
    fail_overline: 'Errore',
    payment_not_confirmed_title: 'Pagamento non confermato',
    retry_contact: 'Riprova o contatta l’assistenza.',
    cancelled_overline: '— Pagamento annullato',
    no_charge: 'Nessun addebito effettuato',
    can_retry: 'Puoi avviare un nuovo pagamento in qualsiasi momento.',
  },
  de: {
    trust_secure: '100% sichere Zahlung',
    trust_fast_ship: 'Schneller Versand',
    trust_money_back: 'Zufrieden oder Geld zurück',
    finalize_order: 'Bestellung abschließen',
    one_step: 'Alles in einem Schritt · sofortige Zahlung',
    your_details: 'Ihre Angaben',
    shipping: 'Versand',
    payment: 'Zahlung',
    loading_payment: 'Zahlungsmodul wird geladen…',
    summary: 'Übersicht',
    qty: 'Menge',
    subtotal: 'Zwischensumme',
    to_choose: '— auswählen —',
    total: 'Gesamt',
    note_encrypted: 'Ihre Daten sind Ende-zu-Ende verschlüsselt. Zahlung zertifiziert nach PCI DSS Level 1.',
    note_ship_after: 'Versand nach Zahlungsbestätigung. Sie erhalten eine E-Mail mit Ihrer Sendungsnummer.',
    note_money_back: '14 Tage Geld-zurück-Garantie.',
    need_help: 'Brauchen Sie Hilfe?',
    store_fallback: 'Shop',
    bogo_free: '🎁 1 kaufen, 1 gratis',
    bogo_percent_summary: '🎁 2. Artikel reduziert',
    offer_free: '🎁 1 kaufen, 1 gratis',
    offer_percent: '🎁 2. Artikel zu -{pct}%',
    skipped_one: '1 Artikel im Warenkorb ist für diese Schnellzahlung nicht verfügbar und wurde nicht in die Summe aufgenommen.',
    skipped_many: '{n} Artikel im Warenkorb sind für diese Schnellzahlung nicht verfügbar und wurden nicht in die Summe aufgenommen.',
    email: 'E-Mail',
    email_ph: 'sie@beispiel.com',
    first_name: 'Vorname',
    last_name: 'Nachname',
    address: 'Adresse',
    address_ph: 'Zum Suchen tippen…',
    searching: 'Suche…',
    no_result: 'Keine Ergebnisse — manuell eingeben',
    city: 'Stadt',
    postal_code: 'Postleitzahl',
    country: 'Land',
    phone: 'Telefon',
    no_shipping: 'Keine Versandoption verfügbar. Bitte kontaktieren Sie den Händler.',
    free: 'Kostenlos',
    err_choose_shipping: 'Bitte wählen Sie eine Versandoption.',
    toast_choose_shipping: 'Wählen Sie eine Versandoption',
    err_complete_info: 'Bitte vervollständigen Sie Ihre Angaben oben.',
    toast_incomplete_info: 'Unvollständige Angaben',
    err_check_payment: 'Überprüfen Sie Ihre Zahlungsdaten',
    err_payment: 'Zahlungsfehler',
    err_generic: 'Fehler',
    processing: 'Zahlung wird verarbeitet...',
    pay: 'Bezahlen',
    choose_shipping_btn: 'Versand auswählen',
    terms: 'Mit Klick auf „Bezahlen“ akzeptieren Sie unsere AGB. Keine Belastung vor der Bestätigung.',
    secure_pay: 'Sichere und verschlüsselte Zahlung',
    or_pay_card: 'oder mit Karte bezahlen',
    product_not_found: 'Produkt nicht gefunden',
    loading_secure: 'Sichere Zahlung wird geladen…',
    ph_cardholder: 'Name auf der Karte',
    ph_cardnumber: 'Kartennummer',
    secured_viva: 'Zahlung gesichert durch Viva Wallet · Ihre Kartendaten gelangen nie auf unsere Server.',
    secured_payzen: 'Zahlung gesichert durch PayZen · Ihre Kartendaten laufen nie über unsere Server.',
    owner_only_overline: 'Eingeschränkter Zugriff',
    owner_only_title: 'Diese Seite ist dem Käufer vorbehalten',
    owner_only_text: 'Die Bestellübersicht ist nur in dem Browser sichtbar, mit dem der Kauf getätigt wurde. Falls Sie das sind, öffnen Sie die Seite erneut aus Ihrem Bestell-Tab oder prüfen Sie die Bestätigungs-E-Mail.',
    payzen_embedded_hint: 'Geben Sie Ihre Daten ein und wählen Sie den Versand: das sichere Kartenformular erscheint hier.',
    viva_embedded_hint: 'Füllen Sie alle Ihre Angaben aus und wählen Sie den Versand, klicken Sie dann auf „Bezahlen“: Das sichere Kartenformular erscheint unten.',
    card_declined: 'Karte abgelehnt oder ungültige Daten',
    payment_not_confirmed: 'Zahlung nicht bestätigt',
    verification: 'Überprüfung',
    confirming_payment: 'Zahlung wird bestätigt...',
    validating: 'Zahlung wird validiert und Bestellung erstellt.',
    payment_confirmed_overline: '— Zahlung bestätigt',
    thank_you: 'Vielen Dank für Ihren Einkauf',
    payment_processed_pre: 'Ihre Zahlung von',
    payment_processed_post: 'wurde erfolgreich verarbeitet.',
    order: 'Bestellung',
    redirecting: 'Weiterleitung zur Bestellbestätigung…',
    shopify_failed_pre: 'Zahlung OK, aber Bestellerstellung fehlgeschlagen:',
    back_home: 'Zurück zur Startseite',
    pending_overline: '— Validierung läuft',
    pending_title: 'Zahlung wird validiert',
    pending_body_amount_pre: 'Ihre Zahlung von',
    pending_body_no_amount: 'Ihre Zahlung',
    pending_body_rest: 'wird von Ihrer Zahlungsmethode validiert (z. B. Klarna). Sie erhalten eine E-Mail-Bestätigung, sobald sie akzeptiert wurde — Ihre Bestellung wird dann automatisch bearbeitet.',
    timeout_overline: 'Zeitüberschreitung',
    fail_overline: 'Fehlgeschlagen',
    payment_not_confirmed_title: 'Zahlung nicht bestätigt',
    retry_contact: 'Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
    cancelled_overline: '— Zahlung abgebrochen',
    no_charge: 'Es wurde nichts belastet',
    can_retry: 'Sie können jederzeit eine neue Zahlung starten.',
  },
  pl: {
    trust_secure: 'Płatność w 100% bezpieczna',
    trust_fast_ship: 'Szybka wysyłka',
    trust_money_back: 'Gwarancja zwrotu pieniędzy',
    finalize_order: 'Sfinalizuj swoje zamówienie',
    one_step: 'Wszystko w jednym kroku · natychmiastowa płatność',
    your_details: 'Twoje dane',
    shipping: 'Dostawa',
    payment: 'Płatność',
    loading_payment: 'Ładowanie modułu płatności…',
    summary: 'Podsumowanie',
    qty: 'Ilość',
    subtotal: 'Suma częściowa',
    to_choose: '— do wyboru —',
    total: 'Razem',
    note_encrypted: 'Twoje dane są szyfrowane od początku do końca. Płatność z certyfikatem PCI DSS Level 1.',
    note_ship_after: 'Wysyłka po potwierdzeniu płatności. Otrzymasz e-mail z numerem śledzenia przesyłki.',
    note_money_back: 'Gwarancja zwrotu pieniędzy w ciągu 14 dni.',
    need_help: 'Potrzebujesz pomocy?',
    store_fallback: 'Sklep',
    bogo_free: '🎁 1 kupiony, 1 gratis',
    bogo_percent_summary: '🎁 2. produkt przeceniony',
    offer_free: '🎁 1 kupiony, 1 gratis',
    offer_percent: '🎁 2. produkt -{pct}%',
    skipped_one: '1 produkt z koszyka jest niedostępny dla tej szybkiej płatności i nie został uwzględniony w sumie.',
    skipped_many: '{n} produkty(-ów) z koszyka są niedostępne dla tej szybkiej płatności i nie zostały uwzględnione w sumie.',
    email: 'E-mail',
    email_ph: 'ty@przyklad.com',
    first_name: 'Imię',
    last_name: 'Nazwisko',
    address: 'Adres',
    address_ph: 'Zacznij pisać, aby wyszukać…',
    searching: 'Wyszukiwanie…',
    no_result: 'Brak wyników — wpisz ręcznie',
    city: 'Miasto',
    postal_code: 'Kod pocztowy',
    country: 'Kraj',
    phone: 'Telefon',
    no_shipping: 'Brak dostępnych opcji dostawy. Skontaktuj się ze sprzedawcą.',
    free: 'Gratis',
    err_choose_shipping: 'Wybierz opcję dostawy.',
    toast_choose_shipping: 'Wybierz opcję dostawy',
    err_complete_info: 'Uzupełnij swoje dane powyżej.',
    toast_incomplete_info: 'Niekompletne dane',
    err_check_payment: 'Sprawdź dane płatności',
    err_payment: 'Błąd płatności',
    err_generic: 'Błąd',
    processing: 'Przetwarzanie płatności...',
    pay: 'Zapłać',
    choose_shipping_btn: 'Wybierz dostawę',
    terms: 'Klikając „Zapłać”, akceptujesz nasz regulamin. Żadnych obciążeń przed potwierdzeniem.',
    secure_pay: 'Bezpieczna, szyfrowana płatność',
    or_pay_card: 'lub zapłać kartą',
    product_not_found: 'Nie znaleziono produktu',
    loading_secure: 'Ładowanie bezpiecznej płatności…',
    ph_cardholder: 'Imię i nazwisko na karcie',
    ph_cardnumber: 'Numer karty',
    secured_viva: 'Płatność zabezpieczona przez Viva Wallet · dane Twojej karty nigdy nie przechodzą przez nasze serwery.',
    secured_payzen: 'Płatność zabezpieczona przez PayZen · dane karty nigdy nie przechodzą przez nasze serwery.',
    owner_only_overline: 'Dostęp ograniczony',
    owner_only_title: 'Ta strona jest zarezerwowana dla kupującego',
    owner_only_text: 'Podsumowanie zamówienia jest widoczne tylko w przeglądarce, w której dokonano zakupu. Jeśli to Ty, otwórz stronę ponownie z karty zamówienia lub sprawdź e-mail z potwierdzeniem.',
    payzen_embedded_hint: 'Uzupełnij dane i wybierz dostawę: bezpieczny formularz karty pojawi się tutaj.',
    viva_embedded_hint: 'Uzupełnij wszystkie dane i wybierz dostawę, a następnie kliknij „Zapłać”: poniżej pojawi się bezpieczny formularz karty.',
    card_declined: 'Karta odrzucona lub nieprawidłowe dane',
    payment_not_confirmed: 'Płatność niepotwierdzona',
    verification: 'Weryfikacja',
    confirming_payment: 'Potwierdzanie płatności...',
    validating: 'Walidacja płatności i tworzenie zamówienia.',
    payment_confirmed_overline: '— Płatność potwierdzona',
    thank_you: 'Dziękujemy za zakup',
    payment_processed_pre: 'Twoja płatność w wysokości',
    payment_processed_post: 'została pomyślnie przetworzona.',
    order: 'Zamówienie',
    redirecting: 'Przekierowanie do potwierdzenia zamówienia…',
    shopify_failed_pre: 'Płatność OK, ale utworzenie zamówienia nie powiodło się:',
    back_home: 'Powrót do strony głównej',
    pending_overline: '— Trwa weryfikacja',
    pending_title: 'Płatność w trakcie weryfikacji',
    pending_body_amount_pre: 'Twoja płatność w wysokości',
    pending_body_no_amount: 'Twoja płatność',
    pending_body_rest: 'jest weryfikowana przez Twoją metodę płatności (np. Klarna). Otrzymasz potwierdzenie e-mailem, gdy tylko zostanie zaakceptowana — Twoje zamówienie zostanie wtedy przetworzone automatycznie.',
    timeout_overline: 'Przekroczono limit czasu',
    fail_overline: 'Niepowodzenie',
    payment_not_confirmed_title: 'Płatność niepotwierdzona',
    retry_contact: 'Spróbuj ponownie lub skontaktuj się z pomocą techniczną.',
    cancelled_overline: '— Płatność anulowana',
    no_charge: 'Nie pobrano żadnych opłat',
    can_retry: 'Możesz ponowić płatność w dowolnym momencie.',
  },
  sv: {
    trust_secure: 'Betalning 100% säker',
    trust_fast_ship: 'Snabb leverans',
    trust_money_back: 'Nöjd-kund-garanti',
    finalize_order: 'Slutför din beställning',
    one_step: 'Allt i ett steg · omedelbar betalning',
    your_details: 'Dina uppgifter',
    shipping: 'Leverans',
    payment: 'Betalning',
    loading_payment: 'Laddar betalningsmodulen…',
    summary: 'Sammanfattning',
    qty: 'Antal',
    subtotal: 'Delsumma',
    to_choose: '— att välja —',
    total: 'Totalt',
    note_encrypted: 'Dina uppgifter är krypterade från början till slut. Betalning certifierad PCI DSS Level 1.',
    note_ship_after: 'Leverans efter bekräftad betalning. Du får ett e-postmeddelande med ditt spårningsnummer.',
    note_money_back: 'Nöjd-kund-garanti inom 14 dagar.',
    need_help: 'Behöver du hjälp?',
    store_fallback: 'Butik',
    bogo_free: '🎁 Köp 1, få 1 gratis',
    bogo_percent_summary: '🎁 Andra varan rabatterad',
    offer_free: '🎁 Köp 1, få 1 gratis',
    offer_percent: '🎁 Andra till -{pct}%',
    skipped_one: '1 vara i varukorgen är inte tillgänglig för denna snabbutcheckning och räknades inte in i summan.',
    skipped_many: '{n} varor i varukorgen är inte tillgängliga för denna snabbutcheckning och räknades inte in i summan.',
    email: 'E-post',
    email_ph: 'du@exempel.com',
    first_name: 'Förnamn',
    last_name: 'Efternamn',
    address: 'Adress',
    address_ph: 'Börja skriva för att söka…',
    searching: 'Söker…',
    no_result: 'Inga resultat — ange manuellt',
    city: 'Stad',
    postal_code: 'Postnummer',
    country: 'Land',
    phone: 'Telefon',
    no_shipping: 'Inga leveransalternativ tillgängliga. Kontakta säljaren.',
    free: 'Gratis',
    err_choose_shipping: 'Välj ett leveransalternativ.',
    toast_choose_shipping: 'Välj ett leveransalternativ',
    err_complete_info: 'Fyll i dina uppgifter ovan.',
    toast_incomplete_info: 'Ofullständiga uppgifter',
    err_check_payment: 'Kontrollera dina betalningsuppgifter',
    err_payment: 'Betalningsfel',
    err_generic: 'Fel',
    processing: 'Betalning pågår...',
    pay: 'Betala',
    choose_shipping_btn: 'Välj leverans',
    terms: 'Genom att klicka på "Betala" godkänner du våra villkor. Ingen debitering före bekräftelse.',
    secure_pay: 'Säker och krypterad betalning',
    card_gate_hint: 'Betalningen aktiveras automatiskt när du har fyllt i din betalningsmetod.',
    or_pay_card: 'eller betala med kort',
    product_not_found: 'Produkten hittades inte',
    loading_secure: 'Laddar säker betalning…',
    ph_cardholder: 'Namn på kortet',
    ph_cardnumber: 'Kortnummer',
    secured_viva: 'Betalning säkrad av Viva Wallet · dina kortuppgifter passerar aldrig våra servrar.',
    secured_payzen: 'Betalning säkrad av PayZen · dina kortuppgifter passerar aldrig våra servrar.',
    owner_only_overline: 'Begränsad åtkomst',
    owner_only_title: 'Den här sidan är reserverad för köparen',
    owner_only_text: 'Ordersammanfattningen visas bara i webbläsaren där köpet gjordes. Om det är du, öppna sidan igen från din orderflik eller se bekräftelsemejlet.',
    payzen_embedded_hint: 'Fyll i dina uppgifter och välj frakt: det säkra kortformuläret visas här.',
    viva_embedded_hint: 'Fyll i alla dina uppgifter och välj leverans, klicka sedan på ”Betala”: det säkra kortformuläret visas nedan.',
    card_declined: 'Kortet nekades eller ogiltiga uppgifter',
    payment_not_confirmed: 'Betalning ej bekräftad',
    verification: 'Verifiering',
    confirming_payment: 'Bekräftar betalning...',
    validating: 'Validerar betalningen och skapar beställningen.',
    payment_confirmed_overline: '— Betalning bekräftad',
    thank_you: 'Tack för ditt köp',
    payment_processed_pre: 'Din betalning på',
    payment_processed_post: 'har behandlats.',
    order: 'Beställning',
    redirecting: 'Omdirigerar till orderbekräftelsen…',
    shopify_failed_pre: 'Betalning OK men det gick inte att skapa beställningen:',
    back_home: 'Tillbaka till startsidan',
    pending_overline: '— Validering pågår',
    pending_title: 'Betalning under validering',
    pending_body_amount_pre: 'Din betalning på',
    pending_body_no_amount: 'Din betalning',
    pending_body_rest: 'valideras av din betalningsmetod (t.ex. Klarna). Du får en bekräftelse via e-post så snart den godkänns — din beställning behandlas då automatiskt.',
    timeout_overline: 'Tidsgränsen överskreds',
    fail_overline: 'Misslyckades',
    payment_not_confirmed_title: 'Betalning ej bekräftad',
    retry_contact: 'Försök igen eller kontakta supporten.',
    cancelled_overline: '— Betalning avbruten',
    no_charge: 'Ingen debitering gjordes',
    can_retry: 'Du kan starta en ny betalning när som helst.',
  },
};

export const getT = (lang) => TRANSLATIONS[lang] || TRANSLATIONS.fr;

// Detect the customer's browser language, restricted to the languages we
// actually support. Returns '' when none match.
export const detectBrowserLang = () => {
  if (typeof navigator === 'undefined') return '';
  const langs = (navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language || ''];
  for (const l of langs) {
    if (!l) continue;
    const code = l.slice(0, 2).toLowerCase();
    if (TRANSLATIONS[code]) return code;
  }
  return '';
};

// Resolve the active checkout language. Priority:
//   1) STORE-configured language (Personnalisation) — the merchant's choice,
//   2) IP-detected language (passed in by the caller, from /public/geo),
//   3) the customer's browser language,
//   4) French.
export const resolveLang = (storeLang, ipLang) =>
  (TRANSLATIONS[storeLang] ? storeLang
    : (TRANSLATIONS[ipLang] ? ipLang : detectBrowserLang())) || 'fr';

// Map an ISO country code to a supported checkout language. Used as a fallback
// (step 2 above) when the merchant hasn't fixed a language in Personnalisation.
const COUNTRY_LANG = {
  FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr',
  DE: 'de', AT: 'de', CH: 'de', LI: 'de',
  IT: 'it', SM: 'it', VA: 'it',
  ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', VE: 'es',
  NL: 'nl',
  PL: 'pl',
  SE: 'sv',
  GB: 'en', US: 'en', IE: 'en', AU: 'en', CA: 'en', NZ: 'en',
};
export const langFromCountry = (cc) => {
  if (!cc) return '';
  const l = COUNTRY_LANG[String(cc).toUpperCase()];
  return (l && TRANSLATIONS[l]) ? l : '';
};

// Detect the customer's country from their browser locale region subtag
// (e.g. "nl-NL" -> "NL"). Restricted to `supported` codes when provided.
export const detectCountry = (supported) => {
  if (typeof navigator === 'undefined') return '';
  const langs = (navigator.languages && navigator.languages.length)
    ? navigator.languages
    : [navigator.language || ''];
  for (const l of langs) {
    const m = /[-_]([A-Za-z]{2})$/.exec(l || '');
    if (m) {
      const cc = m[1].toUpperCase();
      if (!supported || supported.includes(cc)) return cc;
    }
  }
  return '';
};
